import axios from "@/libs/http";
/**
 * 报告错误
 */
export const reportError = (msg)=>{
    let data = new URLSearchParams()
    data.append('msg',msg)
    return axios.request({
        url: '/report/error',
        data,
        method: 'post'
    })
}
